import React                from 'react';
import { Observe }               from 'rewire-core';
import MainContentFooterPaging   from '../main-navigation/MainContentFooterPaging';
import timecardTestListModel     from './TimecardTestListModel';

const TimecardFooter = React.memo(() => {
  return <Observe render={() => (
    <MainContentFooterPaging model={timecardTestListModel.pagingModel} />
  )} />;
});

export default TimecardFooter;